<template>
<div>   
<div class="container-fluid p-0">
    <nav class="navbar navbar-expand-md bg-primary">
      <ul class="navbar-nav ml-auto">
       
        <li class="nav-item dropdown mr-3 mt-1" :style="{right: '-210px'}">
         
          <div class="menu-item" @click="isOpen = !isOpen">
            <a class="a-icon" href.prevent>
              <h6 class="text-white mt-2 text-capitalize">
                User
                <vs-icon class icon="expand_more"></vs-icon>
              </h6>
            </a>
            <transition name="fade" appear>
              <div class="sub-menu" v-if="isOpen">
                <a class="dropdown-item" @click.prevent="logout2" 
                  >Logout</a
                >
              </div>
            </transition>
          </div>
        </li>
      </ul>
    </nav>
    
  </div>
          <div class="container-fluid pt-5" style="height: 100vh; overflow-y: auto;">
            <div class="row">
              <div class="col-sm-12 ">
                <vs-breadcrumb
                  align="left"
                  :items="[
                    { title: 'You are here : ' },
                   
                    {
                      title: 'Add Participants',
                     
                    },
                    
                   {
                      title: `${trainingInfo.title}`,
                      active: true,
                      class: 'font-bold'
                    }
                  ]"
                ></vs-breadcrumb>
                
              </div>
              <div class="col-sm-12">
                <div class="heading mt-1">
                  <h3 class="text-secondary">Participants' Registration</h3>
                </div>
               
              </div>
            </div>
            <!-- breadcrumb and title row Ends -->
            <div class="row justify-content-center mt-0">
              <div class="col-11 p-0">
                <div class="text-danger font-weight-bold " style="font-size: 16px;">Note: Please register only those participants who have been nominated officially by the department.</div>
                <div class="card">
                  <div class="row p-3">
                    <div class="col-md-12">
                              
                              <!-- <div class="row mt-5"> -->
                                  
                                    <div class="row pt-3">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            CNIC
                                            <span class="text-danger">*</span>
                                          </label> 
                                          <input
                                            v-mask="'(99999) 9999999-9'"
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="cnic"
                                            v-model="cnic"

                                            autocomplete="off"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Participant Name
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            v-model="name"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="name"
                                            autocomplete="off"
                                            @input="name = name.replace(/[^a-zA-Z\s]/g, '')"
                                          />
                                        </div>
                                      </div>
  
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Username
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            v-model="username"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="username"
                                            autocomplete="off"
                                            @keydown.space.prevent
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Contact
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-mask="'(9999)-9999999'"
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="contact"
                                            v-model="mobilenumber"
                                            autocomplete="off"
                                          />
                                        </div>
                                      </div>
                                      <!-- -->
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Department / Section
                                            <span class="text-danger">*</span>
                                          </label>
                                          <selectize
                                            id="select-state department"
                                            class="text-capitalize"
                                            v-model="department"
                                            :searchable="true"
                                          >
                                            <option
                                              v-for="(item,index) in departmentArr"
                                              :key="index"
                                              :value="item.id"
                                              class="text-capitalize"
                                            >
                                              {{item.title}}
                                            </option>
                                          </selectize>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Designation
                                            <span
                                              style="color:rgba(255, 0, 0, 0.78);"
                                              >*</span
                                            >
                                          </label>
                                          <selectize
                                            id="select-state designation"
                                            class="text-capitalize"
                                            v-model="designation"
                                            :searchable="true"
                                          >
                                            <option
                                              v-for="(item,index) in designationArr"
                                              :key="index"
                                              :value="item.id"
                                              class="text-capitalize"
                                            >
                                              {{item.title}}
                                            </option>
                                          </selectize>
                                        </div>
                                      </div>
  
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Sector
                                            <span
                                              style="color:rgba(255, 0, 0, 0.78);"
                                              >*</span
                                            >
                                          </label>
                                          <selectize
                                            id="select-state sector"
                                            class="text-capitalize"
                                            v-model="sector"
                                            :searchable="true"
                                          >
                                            <option
                                              v-for="(item,index) in sectorArr"
                                              :key="index"
                                              :value="item.id"
                                              class="text-capitalize"
                                            >
                                              {{item.name}}
                                            </option>
                                          </selectize>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Institution
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            v-model="institute"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="institution"
                                            autocomplete="off"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Profession
                                            <span class="text-danger">*</span>
                                          </label>
                                          <selectize
                                            id="select-state profession"
                                            class="text-capitalize"
                                            v-model="profession"
                                            :searchable="true"
                                          >
                                            <option
                                              v-for="(item,index) in professionArr"
                                              :key="index"
                                              :value="item.id"
                                              class="text-capitalize"
                                            >
                                              {{item.name}}
                                            </option>
                                          </selectize>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <label style="font-weight:700;"
                                          >Location
                                          <span class="text-danger"
                                            >*</span
                                          ></label
                                        >
                                        <selectize
                                          id="select-state location"
                                          v-model="district"
                                        >
                                          <option
                                            v-for="(item,index) in districtArr"
                                            :key="index"
                                            :value="item.id"
                                          >
                                            {{item.title}},
                                            {{item.province.title}},
                                            {{item.province.country.title}}
                                          </option>
                                        </selectize>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Address
                                          </label>
                                          <input
                                            type="text"
                                            v-model="address"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="address"
                                            autocomplete="off"
                                          />
                                        </div>
                                      </div>
                                      <!-- -->
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Passport
                                            <!-- <span class="text-danger">*</span> -->
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="pasport"
                                            v-model="passport"
                                            autocomplete="off"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Email
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder
                                            id="email"
                                            v-model="email"
                                            autocomplete="off"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label style="font-weight: 700">
                                            Password
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder="This will be used as password"
                                            id="password"
                                            v-model="code"
                                            autocomplete="off"
                                          />
                                        </div>
                                      </div>
  
                                      <div
                                        class="col-sm-4 mt-3"
                                        style="
                                          padding-left: 5px;
                                          display: inline-flex;
                                        "
                                      >
                                        <label
                                          class="col-sm-4 col-form-label"
                                          style="font-weight: 700"
                                        >
                                          Gender
                                          <span
                                            style="color: rgba(255, 0, 0, 0.78)"
                                            >*</span
                                          >
                                        </label>
                                        <div
                                          class="col-sm-4"
                                          style="margin-top: 7px"
                                        >
                                          <vs-radio
                                            v-model="gender"
                                            vs-name="radios1"
                                            style="font-weight: 700"
                                            vs-value="male"
                                            id="male"
                                            >Male</vs-radio
                                          >
                                        </div>
                                        <div
                                          class="col-sm-4"
                                          style="margin-top: 7px"
                                        >
                                          <vs-radio
                                            v-model="gender"
                                            vs-name="radios1"
                                            style="font-weight: 700"
                                            vs-value="female"
                                            id="female"
                                            >Female</vs-radio
                                          >
                                        </div>
                                        <div
                                          class="col-sm-6"
                                          style="margin-top: 7px"
                                        >
                                          <vs-radio
                                            style="font-weight: 700"
                                            v-model="gender"
                                            vs-name="radios1"
                                            vs-value="rather not say"
                                            id="gender"
                                            >Other</vs-radio
                                          >
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-12 text-right">
                                        <b-button
                                          type="button"
                                          class="btn btn-primary btn-sm"
                                          variant="primary"
                                          @click="quickRegistration"
                                          >Register
                                        </b-button>
                                      </div>
                                    </div>
                                
                                    <div class="table-responsive mt-4">
  <div class="col-sm-12">
    <div class="form-group">
      <div class="row">
        <div class="col-sm-12">
          <!-- Scrollable table container -->
          <div class="scroll-table-container">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Sr#</th>
                  <th>Participant Name</th>
                  <th>CNIC</th>
                  <th>Department</th>
                  <th>Designation</th>
                  <th>Sector</th>
                  <th>Contact Number</th>
                  <th>Username</th>
                  <th v-if="isDateValid">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in itemsTrainee" :key="item.id">
                  <td>{{ index + 1 }}</td>
                  <td class="text-capitalize">{{ item.name || ' ' }}</td>
                  <td>{{ item.cnic || ' ' }}</td>
                  <td>{{ item.traineeDepartment || ' ' }}</td>
                  <td>{{ item.traineeDesignation || ' ' }}</td>
                  <td>{{ item.sector || ' ' }}</td>
                  <td>{{ item.contactNo || ' ' }}</td>
                  <td>{{ item.username || ' ' }}</td>
                  <td v-if="isDateValid">
                    <a @click="editRecord(item.id)">
                      <vs-icon class="mr-1" icon="edit" style="color: #007bff; font-size: 20px; font-weight: 600; cursor: pointer;"></vs-icon>
                    </a>
                    <a @click="unassignedTraining(item.id)">
                      <vs-icon class="mr-1" icon="clear" style="color: #ff0000c7; font-size: 20px; font-weight: 600; cursor: pointer;"></vs-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
                              </div>
                           

                    </div>
                  </div>
  
                  <!-- Modal -->
                  <div class="modal2" v-if="isModalOpen">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title">Participant Information</h4>
                          <button type="button" class="close" @click="closeModal">
                            &times;
                          </button>
                        </div>
  
                        <div class="modal-body">
                          <form @submit.prevent="updateAndAssign">
                            <div class="row ml-0 mr-0">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Participant Name
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="name"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="name"
                                    :disabled="!!name"
                                    @input="name = name.replace(/[^a-zA-Z\s]/g, '')"
                                  />
                                </div>
                              </div>
  
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    CNIC
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    v-mask="'(99999) 9999999-9'"
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="cnic"
                                    v-model="cnic"
                                    :disabled="!!cnic"
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Username
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="username"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="username"
                                    :disabled="!!username"
                                    autocomplete="off"
                                    @keydown.space.prevent
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Contact
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    v-mask="'(9999)-9999999'"
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="contact"
                                    v-model="mobilenumber"
                                    :disabled="!!mobilenumber"
                                  />
                                </div>
                              </div>
                              
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700" for="first">
                                    Department / Section
                                    <span class="text-danger">*</span>
                                  </label>
                                  <selectize
                                    id="select-state department"
                                    class="text-capitalize"
                                    v-model="department"
                                    :searchable="true"
                                    :disabled="!!department"
                                  >
                                    <option
                                      v-for="(item,index) in departmentArr"
                                      :key="index"
                                      :value="item.id"
                                      class="text-capitalize"
                                    >
                                      {{item.title}}
                                    </option>
                                  </selectize>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Designation
                                    <span style="color:rgba(255, 0, 0, 0.78);"
                                      >*</span
                                    >
                                  </label>
                                  <selectize
                                    id="select-state designation"
                                    class="text-capitalize"
                                    v-model="designation"
                                    :searchable="true"
                                    :disabled="!!designation"
                                  >
                                    <option
                                      v-for="(item,index) in designationArr"
                                      :key="index"
                                      :value="item.id"
                                      class="text-capitalize"
                                    >
                                      {{item.title}}
                                    </option>
                                  </selectize>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Institution
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    v-model="institute"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="institution"
                                    :disabled="!!institute"
                                    autocomplete="off"
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Sector
                                    <span style="color:rgba(255, 0, 0, 0.78);"
                                      >*</span
                                    >
                                  </label>
                                  <selectize
                                    id="select-state sector"
                                    class="text-capitalize"
                                    v-model="sector"
                                    :searchable="true"
                                    :disabled="!!sector"
                                  >
                                    <option
                                      v-for="(item,index) in sectorArr"
                                      :key="index"
                                      :value="item.id"
                                      class="text-capitalize"
                                    >
                                      {{item.name}}
                                    </option>
                                  </selectize>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Profession
                                    <span class="text-danger">*</span>
                                  </label>
                                  <selectize
                                    id="select-state profession"
                                    class="text-capitalize"
                                    v-model="profession"
                                    :searchable="true"
                                    :disabled="!!profession"
                                  >
                                    <option
                                      v-for="(item,index) in professionArr"
                                      :key="index"
                                      :value="item.id"
                                      class="text-capitalize"
                                    >
                                      {{item.name}}
                                    </option>
                                  </selectize>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <label style="font-weight:700;"
                                  >Location
                                  <span class="text-danger">*</span></label
                                >
                                <selectize
                                  id="select-state location"
                                  v-model="district"
                                  :disabled="!!district"
                                >
                                  <option
                                    v-for="(item,index) in districtArr"
                                    :key="index"
                                    :value="item.id"
                                  >
                                    {{item.title}}, {{item.province.title}},
                                    {{item.province.country.title}}
                                  </option>
                                </selectize>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Address
                                  </label>
                                  <input
                                    type="text"
                                    v-model="address"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="address"
                                    :disabled="!!address"
                                    autocomplete="off"
                                  />
                                </div>
                              </div>
                              
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Passport
                                    
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="passport"
                                    v-model="passport"
                                    :disabled="!!passport"
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700"> Email </label>
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder
                                    id="email"
                                    v-model="email"
                                    :disabled="!!email"
                                  />
                                </div>
                              </div>
                              <!-- <div class="col-md-6">
                                <div class="form-group">
                                  <label style="font-weight: 700">
                                    Password
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    placeholder="This will be used as password"
                                    id="password"
                                    v-model="code"
                                  />
                                </div>
                              </div> -->
  
                              <div
                                class="col-sm-4 mt-3"
                                style="
                                          padding-left: 5px;
                                          display: inline-flex;
                                        "
                              >
                                <label
                                  class="col-sm-4 col-form-label"
                                  style="font-weight: 700"
                                >
                                  Gender
                                  <span style="color: rgba(255, 0, 0, 0.78)"
                                    >*</span
                                  >
                                </label>
                                <div class="col-sm-4" style="margin-top: 7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="font-weight: 700"
                                    vs-value="male"
                                    id="male"
                                    >Male</vs-radio
                                  >
                                </div>
                                <div class="col-sm-4" style="margin-top: 7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="font-weight: 700"
                                    vs-value="female"
                                    id="female"
                                    >Female</vs-radio
                                  >
                                </div>
                                <div class="col-sm-6" style="margin-top: 7px">
                                  <vs-radio
                                    style="font-weight: 700"
                                    v-model="gender"
                                    vs-name="radios1"
                                    vs-value="rather not say"
                                    id="gender"
                                    >Other</vs-radio
                                  >
                                </div>
                              </div>
                            </div>
                           
                            <div class="form-group">
                              <div class="row ml-0 mr-0">
                                <div class="col-sm-12" style="text-align: right">
                                  
                                  <b-button
                                    type="submit"
                                    class="btn btn-primary btn-sm m-1"
                                    variant="primary"
                                    id="update"
                                    >Update & Select</b-button
                                  >
                                  <b-button
                                    class="btn btn-primary btn-sm m-1"
                                    @click="closeModal"
                                    id="cancel"
                                    >Cancel</b-button
                                  >
                                 
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div> 
                  
                </div>
              </div>
            </div>
        
        </div> 
        
  </template>
  <script>
  
  import Selectize from "vue2-selectize";
  import axios from "axios";
  
  
  export default {
    data: () => ({
      isOpen: false,
      role: "5",
      designation: "",
      profession:"",
      professionArr:[],
      valuesArray: [],
      sectorArr:[],
      sector:"",
      radios1: "",
      gender: "",
      success: "",
      passport: "",
      institute: "",
      passing_year: "",
      certificate: "",
      district: "",
      email: "",
      error: "",
      cnic: "",
      username: "",
      address: "",
      userId: "",
      primaryUserId:"",
      rolesArr: [],
      registeredTrainerArr: [],
      trainingId: "",
      trainingCode: "",
      roleuser: "",
      departmentArr: [],
      department: "",
      designationArr: [],
      sessionByArray: [],
      startDate: "",
      endDate: "",
      code: "",
      name: "",
      mobilenumber: "",
      trainingArr: [],
      districtArr: [],
      degreenameArr: [],
      itemsTrainee: [],
      isModalOpen: false,
      trainingInfo: null
    }),
  
    watch: {
     cnic(newVal) {
      // Remove special characters and update the username
      this.username = newVal.replace(/[\s()-]/g, "");
      
      // Check if CNIC is complete (all digits entered)
      if (newVal && !newVal.includes('_')) {

        const alreadyExists = this.itemsTrainee.some(item => item.cnic === newVal);
        if (alreadyExists) {
        this.$bvToast.toast('This participant has already been assigned to this event.', {
          title: 'Duplicate CNIC',
          variant: 'warning',
          solid: true
        });
        return;
      }
        this.traineeExist();
      }
    },
      registeredTrainerArr() {
         if(this.registeredTrainerArr.length > 0){
             this.closeLoading();
         }
      },
    },
    mounted() {
      // Check if trainingInfo exists in localStorage
      const trainingInfoStr = sessionStorage.getItem("trainingInfo");
      if (!trainingInfoStr) {
        this.$router.push("/organizarLogin");
        return;
      }

      try {
        this.trainingInfo = JSON.parse(trainingInfoStr);
        if (!this.trainingInfo || !this.trainingInfo.training_id) {
          this.$router.push("/organizarLogin");
          return;
        }
      } catch (e) {
        this.$router.push("/organizarLogin");
        return;
      }

      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
        .then((response) => {
        
          this.closeLoading();
          this.districtArr = response.data;
        });
      //select all degree names
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
        .then((response) => {
          
          this.closeLoading();
          this.degreenameArr = response.data;
        });
      // department
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
        .then((response) => {
          
          this.closeLoading();
          this.departmentArr = response.data;
        });
      //designation
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all")
        .then((response) => {
          this.closeLoading();
          this.designationArr = response.data;
        });
        // Sector
          axios
        .get(process.env.VUE_APP_BASE_PATH + "/sectors/get")
        .then((response) => {
          this.sectorArr = response.data;
        });
    
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/traineeroles/get")
        .then((response) => {
          
          this.closeLoading();
          this.role = response.data[0].id;
        });
  
      // get all professions
        axios
          .get(process.env.VUE_APP_BASE_PATH + "/professions/get"
          )
          .then(response => {
  
            this.closeLoading();
            this.professionArr = response.data;
          });
          this.allTrainee()
    
  
  
    },
    components: {
      Selectize
    },
  
    methods: {
      // onclick show wizard steps
     
      
    assignedTraining(id) {
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH +
              "/training/open-assignment/trainee",
            {
              trainingId: this.trainingInfo.training_id,
              trainee: id,
            }
          )
          .then((response) => {
            if (response.data.unAuth) {
              this.$toasted.global.errorMsg(
                "Your are Unauthorized. Need to Login Again"
              );
              localStorage.clear();
              setTimeout(() => {
                this.$router.push("/");
              }, 1000);
            }
            if (response.data.tokenExpired) {
              this.$toasted.global.errorMsg(response.data.tokenExpired);
              localStorage.clear();
              setTimeout(() => {
                this.$router.push("/");
              }, 1000);
            }
            this.closeLoading();
            if (response.data.success) {
              this.$toasted.global.successMsg("Assigned Training successfully!");
              this.getAllTraining();
              this.allTrainee();
            }
          });
      },
    
    allTrainee() {
        this.openLoading();
        axios
          .get(
            process.env.VUE_APP_BASE_PATH + "/trainee/show/" + this.trainingInfo.training_id
          )
          .then((response) => {
            this.closeLoading();
            this.itemsTrainee = response.data;
          });
      },
    openLoading() {
        this.$vs.loading({
          type: "material",
        });
      },
    closeLoading() {
          this.$vs.loading.close();
      },
    toastSuccess(msg) {
        this.$bvToast.toast(msg, {
          title: "Success",
          autoHideDelay: 10000,
          variant: "success",
          solid: true,
        });
      },
    toastError(msg) {
        this.$bvToast.toast(msg, {
          title: "Error",
          autoHideDelay: 10000,
          variant: "danger",
          solid: true,
        });
      },
      //Quick training
    quickRegistration() {
        this.inValid = [];
        if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.username) {
        this.inValid.push("Username is required.");
      }
      if (!this.gender) {
        this.inValid.push("Gender type is required.");
      }
        if (!this.department) {
        this.inValid.push("Department type is required.");
      }
      if (!this.district) {
        this.inValid.push("Location type is required.");
      }
      if (!this.designation) {
        this.inValid.push("Designation type is required.");
      }
      if (!this.institute) {
        this.inValid.push("Institute type is required.");
      }
       if (!this.profession) {
        this.inValid.push("Profession is required.");
      }
      if (!this.sector) {
        this.inValid.push("Sector type is required.");
      }
        var phone_no1 = this.mobilenumber;
        if (phone_no1 == null || phone_no1 == undefined) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        } else {
          phone_no1 = phone_no1.replace(/_/g, "");
          if (phone_no1.length < 14) {
            this.inValid.push("Must be valid Number, 0345-9992229");
          }
        }
        if (this.email != '') {
                   if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                            this.inValid.push("Invalid email format.");
                      }
                 }
        var cnic_var = this.cnic;
        if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
          cnic_var = cnic_var.replace(/_/g, "");
          if (cnic_var.length < 17) {
            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
          }
        } else if (
          this.passport == undefined ||
          this.passport == null ||
          this.passport == ""
        ) {
          this.inValid.push("Please Enter Passport Number");
        }
        for (var i = 0; i < this.inValid.length; i++) {
          this.$toasted.global.errorMsg(this.inValid[i]);
        }
        if (!this.inValid.length) {
          // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
          let self = this;
          this.openLoading();
          axios
            .post(process.env.VUE_APP_BASE_PATH + "/open-register/trainee", {
              //insert User informatiion in user table
              name: this.name,
              username: this.username,
              code: this.code,
              contactNo: this.mobilenumber,
              email: this.email,
              gender: this.gender,
              sessionBy: this.trainingInfo.training_id,
              cnic: this.cnic,
              statusApproval: 2,
              passport: this.passport,
              district: this.district,
              address: this.address,
              designation: this.designation,
              institute: this.institute,
              type: "Details Registration",
              sector_id: this.sector,
              profession_id: this.profession,
              department_name: this.department,
              role: 5,
            })
            .then((response) => {
              this.closeLoading();
              if (response.data.success) {
                self.toastSuccess("Record has been added successfully!");
                self.resetForm();
                self.allTrainee();
              } else if (response.data.error) {
                throw response.data.error;
              }
            })
            .catch((error) => {
              self.toastError(error);
            });
        }
      },
    
    resetForm() {
        this.name = "";
        this.username="";
        this.cnic = "";
        this.code = "";
        this.passport = "";
        this.gender = "";
        this.mobilenumber = "";
        this.email = "";
        this.country = "";
        this.province = "";
        this.district = "";
        this.address = "";
        this.department = "";
        this.designation = "";
        this.certificate = "";
        this.passing_year = "";
        this.institute = "";
        this.sector = "";
        this.profession = "";
      },
      
    closeModal() {
              this.isModalOpen = false;
              this.resetForm()
          },
    async  updateAndAssign(e){
       e.preventDefault();
        this.inValid = [];
        if (!this.name) {
          this.inValid.push("Name is required.");
        }
        if (!this.username) {
          this.inValid.push("Username is required.");
        }
        if (!this.gender) {
          this.inValid.push("Gender type is required.");
        }
          if (!this.department) {
          this.inValid.push("Department type is required.");
        }
        if (!this.district) {
          this.inValid.push("District type is required.");
        }
        if (!this.designation) {
          this.inValid.push("Designation type is required.");
        }
        if (!this.institute) {
          this.inValid.push("Institute type is required.");
        }
         if (!this.profession) {
          this.inValid.push("Profession is required.");
        }
         if (!this.code) {
          this.inValid.push("Password is required.");
        }
         if (!this.sector) {
          this.inValid.push("Sector type is required.");
        }
        var phone_no1 = this.mobilenumber;
        if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
          this.inValid.push("Must be valid Number, 0345-9992229");
        } else {
          phone_no1 = phone_no1.replace(/_/g, "");
           if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
            this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
          }
        }
        var cnic_var = this.cnic;
        if(cnic_var == ''){ this.inValid.push("CNIC is required.")}
        else{
           if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
          cnic_var = cnic_var.replace(/_/g, "");
          if (cnic_var.length < 17) {
            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
          }
        }
        }
        for (var i = 0; i < this.inValid.length; i++) {
          this.$toasted.global.errorMsg(this.inValid[i]);
        }
        if (!this.inValid.length) {
          // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
          this.openLoading();
          axios
            .post(process.env.VUE_APP_BASE_PATH + "/open-register/update", {
              //insert User informatiion in user table
              name: this.name,
              username: this.username,
              code: this.code,
              role: 5,
              contactNo: this.mobilenumber,
              email: this.email,
              cnic: this.cnic,
              gender: this.gender,
              passport: this.passport,
              type: "Detail Registration",
              id: this.userId,
              district: this.district,
              address: this.address,
              designation: this.designation,
              institute: this.institute,
              department_name: this.department,
              sector_id: this.sector,
              profession_id: this.profession,
              sessionBy: this.trainingInfo.training_id,
              primaryUserId:this.primaryUserId,
            })
  
            .then((response) => {
              this.closeLoading();
              if (response.data.success) {
                this.toastSuccess("Record has been updated successfully!");
                this.assignedTraining(this.userId);
                this.resetForm();
                this.closeModal()
                this.allTrainee();
              } else if (response.data.error) {
                this.toastError(response.data.error);
              }
            })
            .catch((error) => {
              this.toastError(error);
            });
        }
  
      },
       
    traineeExist() {
          if (this.cnic && !this.cnic.includes('_')) {
            this.openLoading();
            axios
            .post(
              process.env.VUE_APP_BASE_PATH + "/trainee/is-trainee-exist/",{
                cnic: this.cnic
              }
            )
              .then((response) => {
                this.closeLoading();
                if (response.data) {
                  this.toastSuccess("A Participant with this CNIC already exists in the system.");
                  // Open modal and populate fields
                  this.isModalOpen = true;
                  this.name = response.data.name;
                  this.username = response.data.username;
                  this.mobilenumber = response.data.contactNo;
                  this.email = response.data.email;
                  this.cnic = response.data.cnic;
                  this.passport = response.data.passportNo;
                  this.gender = response.data.gender;
                  this.userId = response.data.trainee_id;
                  this.district = response.data.district_id;
                  this.address = response.data.address;
                  this.designation = response.data.designation;
                  this.institute = response.data.institution;
                  this.department = response.data.department_name;
                  this.sector = response.data.sector_id;
                  this.profession = response.data.profession_id || '';
                  this.primaryUserId = response.data.user_trainee_id || '';
                  this.code = response.data.code;
                }
              })
              .catch(() => {
                this.closeLoading();
                this.toastError("No Participant Found");
              });
          }
        },

    logout2() {
          sessionStorage.removeItem("trainingInfo");
          this.$router.push({ path: "/focalpointlogin" });
         },
         
    },
  
  
  };
</script>

<style scoped>
  .card{
    border-radius: 8px;
    background-color: #f4f4f4;
  }
  .vs-breadcrumb{
    font-size: 14px;
    font-weight: 700;
  }
  .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
   /* Header */
   #menu-toggle {
    cursor: pointer !important;
  }
  .vs-dropdown-menu .con-input {
  margin-bottom: 20px;
}
.bg-primary {
  /* height: 50px !important; */
  background: #06a6e0 !important;
}
nav .menu-item svg {
  width: 10px;
  margin-left: 10px;
}

nav .menu-item .sub-menu {
  position: absolute;
  background-color: #ffff;
  height: 40px;
  width:120px !important;
  top: 39px;
  left: 65%;
  transform: translateX(-50%);
  width: max-content;
  border-radius: 0px 0px 16px 16px;
  border: 0.5px solid #C1BFBF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}
.scroll-table-container {
  max-height: 300px;
  overflow-y: scroll;
  position: relative;
}

.scroll-table-container thead th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
}
</style>
  